// It link for prevent validation errors
export const NO_PAYMENT = 'https://no.payment.wwt'
